export default "__VITE_ASSET__687f9caa__"